import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { EmailAccountInterface } from "../../Entity/Entities/EmailAccount/EmailAccountInterface";
import Translator from "../../Translation/Translator";

export default function* emailAccountDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_REQUEST
    });

    yield call(Http.delete, `email-account/${action.payload?.emailAccount.id}`);

    const emailAccount: EmailAccountInterface = action.payload?.emailAccount.reinitialize({
      removed: true
    });

    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_SUCCESS,
      payload: {
        emailAccount: emailAccount
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-action-successful"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }

  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_FAILURE,
      payload: {
        err: err
      }
    });

  }
}

export function* watchEmailAccountDelete() {
  yield takeEvery(Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_DELETE_START, emailAccountDelete);
}
